import { HTMLAttributes } from 'react';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type PaginationLinkProps = HTMLAttributes<HTMLLIElement> & {
  onPageChange: (page: number) => void;
  page: number;
  active?: boolean;
  disabled?: boolean;
  variant?: 'default' | 'circle';
};

export const PaginationLink = ({
  children,
  onPageChange,
  page,
  active = false,
  disabled = false,
  variant = 'default',
}: PaginationLinkProps) => (
  <li>
    <button
      className={joinClassNames(
        styles.paginationItem,
        disabled && styles.disabled,
        active && styles.active,
        variant !== 'default' && styles[variant]
      )}
      onClick={() => !disabled && onPageChange(page)}
    >
      {children}
    </button>
  </li>
);

PaginationLink.displayName = 'PaginationLink';
